import styled from "styled-components";
import { TD } from "./tokens";

// Values from Figma frame "Teacher Dashboard · Returning · Redesign" (266:262).
export const ReturningWrapper = styled.div`
	/* fill the CMS content area edge to edge with the cream canvas */
	margin: -15px;
	min-height: calc(100% + 30px);
	padding: 32px 32px 40px;
	background: ${TD.canvas};
	font-family: ${TD.font};
	color: ${TD.textBody};

	p,
	h1,
	h2,
	h3 {
		margin: 0;
	}

	.stack {
		display: flex;
		flex-direction: column;
		gap: 24px;
	}

	/* ---------- Welcome ---------- */
	.welcome {
		position: relative;
		overflow: hidden;
		display: flex;
		flex-direction: column;
		gap: 28px;
		padding: 32px;
		border-radius: 24px;
		background: ${TD.sidebar};
	}
	.decor {
		position: absolute;
		top: -120px;
		right: 0;
		width: 350px;
		height: 240px;
		opacity: 0.22;
		pointer-events: none;
		span {
			position: absolute;
			border-radius: 50%;
		}
		.c1 {
			width: 150px;
			height: 150px;
			left: 0;
			top: 20px;
			background: #acdcea;
		}
		.c2 {
			width: 240px;
			height: 240px;
			left: 110px;
			top: 0;
			background: ${TD.pastelPink};
		}
		.c3 {
			width: 96px;
			height: 96px;
			left: 230px;
			top: 138px;
			background: ${TD.tintYellow};
		}
	}
	.greeting {
		position: relative;
		display: flex;
		align-items: center;
		gap: 24px;
	}
	.welcome-avatar {
		width: 96px;
		height: 96px;
		flex-shrink: 0;
		border-radius: 50%;
		border: 4px solid ${TD.yellow};
		background: ${TD.tintNavy};
		color: ${TD.navy};
		font-size: 32px;
		font-weight: 600;
		display: flex;
		align-items: center;
		justify-content: center;
		overflow: hidden;
		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}
	.greeting-text {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		gap: 10px;
		max-width: 640px;
	}
	.pilot-badge {
		display: inline-flex;
		align-items: center;
		gap: 6px;
		padding: 5px 12px 5px 10px;
		border-radius: 999px;
		background: ${TD.yellow};
		color: ${TD.navy};
		font-size: 12px;
		font-weight: 600;
	}
	.welcome-title {
		font-size: 32px;
		line-height: 38px;
		font-weight: 600;
		color: ${TD.white};
	}
	.welcome-text {
		font-size: 16px;
		line-height: 24px;
		color: ${TD.borderStrong};
	}
	.quick-start {
		position: relative;
		display: grid;
		grid-template-columns: repeat(4, minmax(0, 1fr));
		gap: 16px;
	}
	.qs-tile {
		display: flex;
		flex-direction: column;
		gap: 14px;
		padding: 20px;
		border-radius: 18px;
		background: ${TD.white};
		text-align: left;
		border: 0;
		cursor: pointer;
		font-family: ${TD.font};
		transition:
			transform 0.2s ease,
			box-shadow 0.2s ease;
		&:hover {
			transform: translateY(-2px);
			box-shadow: 0 10px 24px rgba(0, 0, 0, 0.18);
		}
		&:hover .arrow {
			background: ${TD.navy};
			svg {
				stroke: ${TD.white};
			}
		}
	}
	.qs-top {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.qs-icon {
		width: 48px;
		height: 48px;
		border-radius: 14px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.arrow {
		width: 32px;
		height: 32px;
		border-radius: 999px;
		background: ${TD.tintNavy};
		display: flex;
		align-items: center;
		justify-content: center;
		transition: background 0.2s ease;
	}
	.qs-title {
		font-size: 16px;
		font-weight: 600;
		color: ${TD.navy};
	}
	.qs-text {
		margin-top: 4px;
		font-size: 13px;
		line-height: 19px;
		color: ${TD.textMuted};
	}

	/* ---------- Rows and cards ---------- */
	.row {
		display: grid;
		gap: 24px;
		align-items: stretch;
	}
	/* left card takes 2/3, right card 1/3 (never under 360px), so the left cards stay compact on wide screens */
	.row-wide {
		grid-template-columns: minmax(0, 2fr) minmax(360px, 1fr);
	}
	.row-three {
		grid-template-columns: repeat(3, minmax(0, 1fr));
	}
	.card {
		display: flex;
		flex-direction: column;
		gap: 16px;
		min-width: 0;
		padding: 22px 24px 24px;
		background: ${TD.white};
		border: 1px solid ${TD.border};
		border-radius: 20px;
		box-shadow: ${TD.cardShadow};
	}
	.card-header {
		display: flex;
		align-items: center;
		gap: 10px;
		min-height: 32px;
	}
	.card-subtitle {
		margin-top: 2px;
		font-size: 13px;
		color: ${TD.textMuted};
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	.card-title {
		flex: 1;
		font-size: 18px;
		font-weight: 600;
		color: ${TD.navy};
		display: flex;
		align-items: center;
		gap: 10px;
	}
	.view-all {
		display: inline-flex;
		align-items: center;
		gap: 4px;
		padding: 0;
		border: 0;
		background: transparent;
		color: ${TD.teal};
		font-family: ${TD.font};
		font-size: 13px;
		font-weight: 600;
		cursor: pointer;
		white-space: nowrap;
		&:hover {
			text-decoration: underline;
		}
	}
	.divider + .divider,
	.list > * + * {
		border-top: 1px solid ${TD.border};
	}
	.clickable {
		cursor: pointer;
		&:hover .chev {
			transform: translateX(2px);
		}
	}
	.chev {
		flex-shrink: 0;
		transition: transform 0.2s ease;
	}
	.tile {
		flex-shrink: 0;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.muted {
		color: ${TD.textMuted};
	}
	.ellipsis {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	/* Active Assessments table */
	.table-head,
	.table-row {
		display: grid;
		/* spare width is shared by all columns, so the gaps between them stay even on wide screens */
		grid-template-columns: minmax(180px, 2fr) minmax(64px, 0.8fr) minmax(90px, 0.8fr) minmax(92px, 0.9fr) minmax(144px, 1.3fr) 20px;
		gap: 12px;
		align-items: center;
	}
	.table-head {
		padding: 10px 12px;
		border-radius: 10px;
		background: ${TD.canvas};
		color: ${TD.textMuted};
		font-size: 11px;
		font-weight: 600;
		letter-spacing: 0.8px;
		text-transform: uppercase;
	}
	.table-row {
		padding: 16px 12px;
	}
	.assessment-cell {
		display: flex;
		align-items: center;
		gap: 12px;
		min-width: 0;
		cursor: pointer;
	}
	.name {
		font-size: 15px;
		font-weight: 600;
		color: ${TD.navy};
	}
	.sub {
		margin-top: 2px;
		font-size: 13px;
		color: ${TD.textMuted};
	}
	.cell {
		font-size: 14px;
		color: ${TD.textBody};
	}
	.cell-year,
	.cell-date,
	.progress-label span {
		white-space: nowrap;
	}
	/* long assessment names wrap to two lines instead of being cut off */
	.assessment-cell .name {
		white-space: normal;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		overflow: hidden;
	}
	.progress-label {
		display: flex;
		justify-content: space-between;
		gap: 8px;
		margin-bottom: 6px;
		font-size: 12px;
		color: ${TD.textMuted};
		strong {
			font-weight: 600;
			color: ${TD.navy};
		}
	}
	.bar {
		position: relative;
		height: 6px;
		border-radius: 999px;
		background: ${TD.tintNavy};
		overflow: hidden;
		span {
			position: absolute;
			left: 0;
			top: 0;
			bottom: 0;
			border-radius: 999px;
		}
	}
	.more {
		width: 20px;
		height: 20px;
		padding: 0;
		border: 0;
		background: transparent;
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 6px;
		&:hover {
			background: ${TD.tintNavy};
		}
	}

	/* Recent Results */
	.result-row {
		display: flex;
		align-items: center;
		gap: 12px;
		padding: 14px 0;
	}
	.result-text {
		flex: 1;
		min-width: 0;
		.title {
			font-size: 14px;
			font-weight: 600;
			color: ${TD.navy};
		}
		.meta {
			margin-top: 3px;
			font-size: 12px;
			color: ${TD.textMuted};
		}
		.label {
			margin-top: 3px;
			font-size: 12px;
			font-weight: 500;
			color: ${TD.textMuted};
		}
	}
	.ring {
		position: relative;
		width: 56px;
		height: 56px;
		flex-shrink: 0;
		svg {
			transform: rotate(-90deg);
		}
		span {
			position: absolute;
			inset: 0;
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 13px;
			font-weight: 600;
			color: ${TD.navy};
		}
	}

	/* Class Performance */
	.select {
		width: 300px;
		max-width: 100%;
		.ant-select-selector {
			height: 38px !important;
			padding: 0 12px 0 14px !important;
			border: 1px solid ${TD.borderStrong} !important;
			border-radius: 10px !important;
			align-items: center;
			font-family: ${TD.font};
			font-weight: 500;
			font-size: 14px;
			color: ${TD.navy};
		}
		.ant-select-selection-item {
			line-height: 36px !important;
		}
	}
	.stats {
		display: grid;
		grid-template-columns: repeat(4, minmax(0, 1fr));
		gap: 16px;
		flex: 1;
	}
	.stat {
		display: flex;
		flex-direction: column;
		gap: 12px;
		padding: 18px;
		border-radius: 16px;
		background: ${TD.canvas};
		border: 1px solid ${TD.border};
		.value {
			font-size: 30px;
			line-height: 36px;
			font-weight: 600;
		}
		.label {
			font-size: 13px;
			line-height: 18px;
			color: ${TD.textMuted};
		}
	}

	/* Most Missed */
	.missed-row {
		display: flex;
		align-items: center;
		gap: 12px;
		padding: 14px 0;
	}
	.rank {
		width: 30px;
		height: 30px;
		border-radius: 999px;
		font-size: 13px;
		font-weight: 600;
	}
	.missed-text {
		flex: 1;
		min-width: 0;
		.module {
			font-size: 12px;
			color: ${TD.textMuted};
		}
		.question {
			margin-top: 2px;
			font-size: 14px;
			font-weight: 600;
			color: ${TD.navy};
			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
			overflow: hidden;
		}
	}
	.pct {
		flex-shrink: 0;
		padding: 4px 8px;
		border-radius: 999px;
		background: ${TD.tintPink};
		color: ${TD.red};
		font-size: 12px;
		font-weight: 600;
		white-space: nowrap;
	}

	/* My Classes */
	.class-row {
		display: flex;
		align-items: center;
		gap: 12px;
		padding: 9px 0;
		.title {
			font-size: 14px;
			font-weight: 600;
			color: ${TD.navy};
		}
		.meta {
			margin-top: 1px;
			font-size: 12px;
			color: ${TD.textMuted};
		}
	}
	.class-list > * + * {
		border-top: 0;
	}

	/* Bank + alert boxes */
	.boxes {
		display: flex;
		flex-direction: column;
		gap: 12px;
	}
	.box {
		display: flex;
		gap: 12px;
		padding: 14px 12px 14px 14px;
		border-radius: 14px;
		background: ${TD.canvas};
		border: 1px solid ${TD.border};
		transition:
			border-color 0.2s ease,
			box-shadow 0.2s ease;
		&.clickable:hover {
			border-color: ${TD.borderStrong};
			box-shadow: ${TD.cardShadow};
		}
		.title {
			font-size: 14px;
			font-weight: 600;
			color: ${TD.navy};
			display: flex;
			align-items: center;
			gap: 6px;
		}
		.meta {
			margin-top: 2px;
			font-size: 12px;
			color: ${TD.textMuted};
		}
	}
	.alert {
		align-items: flex-start;
		.title {
			font-size: 15px;
		}
		.message {
			margin-top: 3px;
			font-size: 13px;
			line-height: 18px;
			color: ${TD.textMuted};
		}
	}

	/* Quick Actions */
	.actions {
		display: grid;
		grid-template-columns: repeat(4, minmax(0, 1fr));
		gap: 16px;
	}
	.action {
		display: flex;
		align-items: center;
		gap: 14px;
		padding: 16px 14px 16px 16px;
		border-radius: 16px;
		background: ${TD.canvas};
		border: 1px solid ${TD.border};
		text-align: left;
		font-family: ${TD.font};
		cursor: pointer;
		transition:
			border-color 0.2s ease,
			box-shadow 0.2s ease;
		&:hover {
			border-color: ${TD.borderStrong};
			box-shadow: ${TD.cardShadow};
		}
		&:hover .chev {
			transform: translateX(2px);
		}
		.title {
			font-size: 15px;
			font-weight: 600;
			color: ${TD.navy};
		}
		.meta {
			margin-top: 1px;
			font-size: 13px;
			color: ${TD.textMuted};
		}
	}

	/* Empty, loading and error states */
	.empty {
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 10px;
		padding: 24px 12px;
		text-align: center;
		color: ${TD.textMuted};
		font-size: 14px;
		.empty-icon {
			width: 48px;
			height: 48px;
			border-radius: 14px;
			background: ${TD.tintNavy};
			display: flex;
			align-items: center;
			justify-content: center;
		}
		.empty-title {
			font-size: 15px;
			font-weight: 600;
			color: ${TD.navy};
		}
	}
	.empty-button {
		margin-top: 4px;
		padding: 8px 16px;
		border: 0;
		border-radius: 999px;
		background: ${TD.red};
		color: ${TD.white};
		font-family: ${TD.font};
		font-size: 14px;
		font-weight: 500;
		cursor: pointer;
	}
	.error-banner {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 16px;
		padding: 14px 18px;
		border-radius: 14px;
		background: ${TD.tintPink};
		color: ${TD.navy};
		font-size: 14px;
	}

	button:focus-visible,
	[role="button"]:focus-visible {
		outline: 2px solid ${TD.teal};
		outline-offset: 2px;
	}

	/* ---------- Responsive ---------- */
	@media (max-width: 1299px) {
		.row-wide {
			grid-template-columns: minmax(0, 1fr);
		}
		.row-three {
			grid-template-columns: repeat(2, minmax(0, 1fr));
		}
		.row-three > :last-child {
			grid-column: 1 / -1;
		}
	}
	@media (max-width: 1099px) {
		.quick-start,
		.actions {
			grid-template-columns: repeat(2, minmax(0, 1fr));
		}
	}
	@media (max-width: 899px) {
		padding: 20px 16px 32px;
		.row-three {
			grid-template-columns: minmax(0, 1fr);
		}
		.stats {
			grid-template-columns: repeat(2, minmax(0, 1fr));
		}
		.table-head {
			display: none;
		}
		.table-row {
			grid-template-columns: minmax(0, 1fr) 20px;
			grid-template-areas: "a m" "c c" "y y" "d d" "p p";
			row-gap: 8px;
			.assessment-cell {
				grid-area: a;
			}
			.cell-class {
				grid-area: c;
			}
			.cell-year {
				grid-area: y;
			}
			.cell-date {
				grid-area: d;
			}
			.cell-progress {
				grid-area: p;
			}
			.cell-more {
				grid-area: m;
			}
		}
		.cell-class::before {
			content: "Class: ";
			color: ${TD.textMuted};
		}
		.cell-year::before {
			content: "Year: ";
			color: ${TD.textMuted};
		}
		.cell-date::before {
			content: "Closes: ";
			color: ${TD.textMuted};
		}
		.card-header {
			flex-wrap: wrap;
		}
		.select {
			width: 100%;
		}
	}
	@media (max-width: 600px) {
		.welcome {
			padding: 24px 20px;
		}
		.greeting {
			flex-direction: column;
			align-items: flex-start;
		}
		.welcome-avatar {
			width: 72px;
			height: 72px;
			font-size: 24px;
		}
		.welcome-title {
			font-size: 26px;
			line-height: 32px;
		}
		.quick-start,
		.actions {
			grid-template-columns: minmax(0, 1fr);
		}
	}
`;
